import { createSelector } from "@ngrx/store";
import { selectUserContactsFeature } from "@State/Features/contacts.feature";


export const selectContacts = selectUserContactsFeature.selectContacts;

export const selectContactsById = (idContact: number) => createSelector(
  selectContacts,
  (contacts) => contacts.find(contact => contact.idContact === idContact)
)
export const selectContactsByNameLastnameAndEmail = (name: string, lastname: string, email: string) => createSelector(
  selectContacts,
  (contacts) => contacts.find(contact => contact.name === name && contact.surname === lastname && contact.email === email)
)
